import PropTypes from 'prop-types';

const pluginManifestShape = PropTypes.shape({
  configurationSchema: PropTypes.string,
  description: PropTypes.string,
  id: PropTypes.string,
  publisherId: PropTypes.string,
  version: PropTypes.string,
  zipHash: PropTypes.string,
});

export default pluginManifestShape;
